import { FadeUp, Stagger, StaggerItem } from "./Motion";

const chapters = [
  {
    n: "01",
    title: "Data Sits in Silos",
    body:
      "Bank statements, GST portals, credit bureaus, and trading networks each hold a piece of the picture — but they don&apos;t speak to each other in an underwriter&apos;s workflow.",
  },
  {
    n: "02",
    title: "Verification is Hard",
    body:
      "A business can have strong monthly revenue, loyal repeat customers, and stable trading relationships — yet trading partners are hard to verify and none of it reaches the credit file.",
  },
  {
    n: "03",
    title: "Good Businesses Get Declined",
    body:
      "Healthy MSMEs are rejected because the data is incomplete, not because they aren&apos;t creditworthy. Lenders miss good opportunities; India&apos;s credit gap persists.",
  },
];

const stats = [
  { k: "Silos", v: "Bank data, GST records, credit bureaus, and trading networks live in disconnected systems." },
  { k: "Access", v: "Lenders cannot easily aggregate MSME data across sources at speed." },
  { k: "Rejections", v: "Creditworthy businesses declined for incomplete data — not lack of creditworthiness." },
];

export const Problem = () => {
  return (
    <section id="problem" className="relative py-24 md:py-36 border-t border-ink/10">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <FadeUp>
          <div className="flex items-center gap-6 mb-16">
            <span className="font-mono-cap text-ink/60">§ 01 — The Problem</span>
            <span className="hair-divider flex-1" />
          </div>
        </FadeUp>

        <div className="grid grid-cols-12 gap-6 md:gap-10">
          <div className="col-span-12 lg:col-span-7">
            <FadeUp>
              <h2 className="font-display text-5xl md:text-7xl text-ink leading-[0.98]">
                Traditional lending <br />
                misses <span className="italic text-teal">healthy</span> businesses.
              </h2>
            </FadeUp>
          </div>
          <div className="col-span-12 lg:col-span-5 lg:pt-4">
            <FadeUp delay={0.15}>
              <p className="font-sans text-base md:text-lg text-ink/70 leading-relaxed">
                Underwriting was built for a world of paperwork. Modern MSMEs
                live in a world of UPI receipts, GST invoices, purchase orders,
                and long-standing distributor relationships — signals that never
                reach the risk model.
              </p>
            </FadeUp>
          </div>
        </div>

        {/* Chapters */}
        <Stagger className="mt-20 md:mt-28 grid grid-cols-12 gap-6 md:gap-10">
          {chapters.map((c) => (
            <StaggerItem key={c.n} className="col-span-12 md:col-span-4">
              <div className="border-t border-ink pt-6">
                <div className="chapter-num text-ink text-7xl md:text-8xl">{c.n}</div>
                <h3 className="font-display text-2xl md:text-3xl text-ink mt-4 leading-tight">
                  {c.title}
                </h3>
                <p
                  className="font-sans text-ink/70 mt-4 leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: c.body }}
                />
              </div>
            </StaggerItem>
          ))}
        </Stagger>

        {/* signal row */}
        <div className="mt-20 md:mt-28 grid grid-cols-12 gap-6 md:gap-10">
          {stats.map((s, i) => (
            <FadeUp key={s.k} delay={i * 0.08} className="col-span-12 md:col-span-4">
              <div className="border border-ink/15 p-6 md:p-8 bg-white">
                <div className="font-display text-3xl md:text-4xl text-ink">
                  {s.k}
                </div>
                <p className="font-sans text-ink/70 mt-3 text-sm md:text-base leading-relaxed">
                  {s.v}
                </p>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
};
